import React, { useState } from "react";
import styled from "styled-components";

import Logo from "components/Logo";
import { H1, Label, Input } from "styles";

function Auth({
  onClick,
  error,
}: {
  onClick: (username: string, password: string) => void;
  error: string;
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <Container>
      <Head>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <H1>Blackbook</H1>
      </Head>
      <Form>
        <Field>
          <Label htmlFor="email">Email</Label>
          <Input
            name="email"
            onChange={(event) => {
              setUsername(event.target.value);
            }}
            noMargin
          />
        </Field>
        <Field>
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            name="password"
            onChange={(event) => {
              setPassword(event.target.value);
            }}
            noMargin
          />
        </Field>
        <Button onClick={() => onClick(username, password)}>Login</Button>
        <span>{error}</span>
      </Form>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 20rem;
  margin: 0 auto;
  text-align: center;
  margin-top: 10rem;
`;

const Head = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const LogoWrapper = styled.div`
  margin-bottom: 1rem;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 16rem;
  margin: 0 auto;
`;

const Field = styled.div`
  display: flex;
  padding-bottom: 1rem;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  width: 6rem;
  align-self: flex-end;
  border: 1px solid #dddfe2;
  border-radius: 0.2rem;
  padding: 0.5rem;
`;

export default Auth;
